var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 15v2h22v-2z"}));
}

Minus.defaultProps = {"viewBox":"0 0 32 32","fill":"#000000","xmlnsV":"https://vecta.io/nano"};

module.exports = Minus;

Minus.default = Minus;
